import { BlockToolbar, ToolbarButton } from './Toolbar'

/** Drag payload for moving a block within the writing (the thoughts panel uses THOUGHT_MIME). */
export const BLOCK_MIME = 'application/x-burrow-block'

/**
 * The small pill inside a hovered or selected image's top-left corner, as in
 * Composer lab's wrap tool: Reposition · Replace · Remove, and nothing else.
 * Where the image sits is the hand's job (drag it; ← and → on the keyboard),
 * and its size and crop the corner's, so neither needs a button. Reposition
 * (it was Crop until Niki, 10/2: the corner crops now) moves the photo in its
 * frame. Replace (Niki, 10/6) picks another photo for the same block, in the
 * cover's order: Reposition · Replace · Remove.
 */
export function ImagePlacementToolbar({
  onReposition,
  onReplace,
  onRemove,
}: {
  onReposition: () => void
  onReplace: () => void
  onRemove: () => void
}) {
  return (
    <BlockToolbar label="Image" tone="photo" className="left-2 top-2 whitespace-nowrap">
      <ToolbarButton title="Reposition the photo in its frame" onClick={onReposition}>
        Reposition
      </ToolbarButton>
      <ToolbarButton title="Replace the photo (or drop one on it)" onClick={onReplace}>
        Replace
      </ToolbarButton>
      <ToolbarButton keys="Backspace Delete" title="Remove (Backspace)" onClick={onRemove}>
        Remove
      </ToolbarButton>
    </BlockToolbar>
  )
}
